import { useQuery } from '@tanstack/react-query'

import { StoriesService } from '../lib/stories.service'

const GET_STORIES_STEPS = 'get-stories-steps'

export const useStoriesSteps = (id: string) => {
  return useQuery({
    queryKey: [GET_STORIES_STEPS, id],
    queryFn: () => StoriesService.getStoriesSteps(id),
    select: data => data.data,
    enabled: Boolean(id)
  })
}
